<!--
    * @Description: 现金宝取现
    * @Author: luoshoufeng@szkingdom.com
    * @Date: 2024-04-30 15:32:31
 * @LastEditors: situgen@szkingdom.com
   -->
<template>
    <div v-if="xjbFundFileFlag">
        <comp-title-dc back-url-name="moneybox" :back-url-query="{ activeIndex: 2 }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/moneyBox' }">
                    {{ $const.getXJBParam("name") }}
                </el-breadcrumb-item>
                <el-breadcrumb-item>取现</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-money-out">
            <el-form
                ref="fundInfo"
                :rules="rules"
                :model="fundInfo"
                inline-message
                label-width="409px"
                v-on:submit.native.prevent
            >
                <el-form-item
                    label="取出账号："
                    prop="pay"
                    style="position: relative"
                    class="payway-list"
                >
                    <el-select v-model="fundInfo.pay" placeholder="请选择取出账号"></el-select>

                    <div
                        v-if="dialogBankLists.length > 0"
                        class="hot-area"
                        v-on:click="selectBank"
                    ></div>
                </el-form-item>
                <el-form-item label="可用余额：" prop="availableMoney">
                    <div class="available-money-box">
                        <div>
                            <span class="available-money">
                                {{ $util.fmtNum(fundInfo.availableMoney) }}
                            </span>
                            元
                        </div>
                        <div class="money-in" v-on:click="backFn">
                            查看{{ $const.getXJBParam("sname") }}总资产
                        </div>
                    </div>
                </el-form-item>
                <el-form-item
                    v-show="fundInfo.sell == '1'"
                    label="当日快取额度："
                    prop="fastavailfundvol"
                >
                    <div class="available-money-box">
                        <div>
                            <span class="available-money">
                                {{ $util.fmtNum(bankInfo.fastavailfundvol) }}
                            </span>
                            元
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="取出金额：" prop="amount">
                    <amount-input
                        v-model="fundInfo.amount"
                        :placeholder="pla"
                    />
                </el-form-item>
                <el-form-item v-if="Number(fundInfo.amount)" label="确认金额：">
                    {{ $util.capitalRMB(fundInfo.amount) }}
                </el-form-item>
                <el-form-item
                    v-if="redeemInfo.selltype && redeemInfo.selltype.indexOf('1') > -1"
                    label="取出方式："
                    prop="sell"
                >
                    <el-radio-group v-model="fundInfo.sell" class="padding-t-10">
                        <el-radio label="0" name="sell">
                            普通取出
                            <div class="sell-font">
                                预计{{
                                    ransDateInfo.redeempaybackdate
                                        ? format(ransDateInfo.redeempaybackdate, "MM-DD")
                                        : "--"
                                }}到帐，多一天收益
                                <div class="margin-t-5">取出无限额</div>
                            </div>
                        </el-radio>
                        <el-radio label="1" name="sell">
                            快速取出
                            <div style="width: 170px" class="sell-font">
                                实时到账，取出当日无收
                                <div class="margin-t-5">
                                    益，限额单笔{{ fastLimitPen }}，单日{{ fastLimitDay }}
                                </div>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="16"
                    />
                    <span
                        class="redemp-btn margin-l-10"
                        v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                    >
                        <span class="like-a">忘记密码？</span>
                    </span>
                </el-form-item>
                <el-form-item style="margin-left: -80px">
                    <div
                        v-if="xjbFundFile.length !== 0"
                        class="check-box bar-pad showChenckbox"
                        style="
                            font-size: 14px;
                            display: flex;
                            align-items: flex-start;
                            padding-left: -10px;
                        "
                    >
                        <ul>
                            <li
                                v-for="(item, index) in xjbFundFile"
                                :key="index"
                                class="flex hcenter"
                            >
                                <el-checkbox
                                    v-model="checkboxs[index].checkbox"
                                    size="mini"
                                    text-color="red"
                                ></el-checkbox>
                                <div>
                                    <span class="ml4 c_999">同意</span>
                                    <a
                                        v-if="item.fileid"
                                        class="file-content"
                                        target="_blank"
                                        v-on:click="getClick(index)"
                                    >
                                        《{{ item.title }}》
                                    </a>
                                    <span v-else class="file-content" v-on:click="argRead(item)">
                                        《{{ item.title }}》
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <el-form-item v-if="fundInfo.sell == '1'" style="margin-left: -80px">
                    <div
                        v-if="protocolArr.length !== 0"
                        class="protocol-checkbox-group"
                    >
                        <div class="protocol-checkbox-label">
                            <input v-model="checkbox" type="checkbox" />
                            <span>我已阅读并同意:</span>
                        </div>
                        <ul>
                            <li v-for="(item, index) in protocolArr" :key="index">
                                <a :href="$util.imgSrc({ fileCode: item.fileid })" target="_blank">
                                    《{{ item.title }}》
                                </a>
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div style="margin-top: 20px">
                        <el-button class="back-btn" v-on:click="backFn">返回重选</el-button>
                        <el-button
                            :class="
                                'confirm-btn ' +
                                (disabeldFlag || isOpen || (!checkbox && fundInfo.sell == '1')
                                    ? 'disable-btn'
                                    : 'active-btn')
                            "
                            :loading="isOpen"
                            :disabled="
                                disabeldFlag || isOpen || (!checkbox && fundInfo.sell == '1')
                            "
                            v-on:click="submitInfo()"
                        >
                            确定
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
            <select-bank
                dialog-title="请选择取出账号"
                :dialog-bank-lists="dialogBankLists"
                :select-bank-show="selectBankShow"
                way="1"
                :is-buy="false"
                v-on:select-bank-close="selectBankClose"
                v-on:select-bank-info="selectBankInfo"
            ></select-bank>
            <el-dialog
                title="取出结果"
                :visible.sync="resultDialog"
                class="prop info-tips"
                width="700px"
                :before-close="resultDialogClose"
            >
                <div>
                    <div class="success-res">
                        <div>
                            <img src="../../assets/img/buy_success.png" alt="" />
                        </div>
                        <div class="success-text">您好，取出成功！</div>
                    </div>
                    <div class="btn-box">
                        <button class="btn-confirm" v-on:click="resultDialogClose">确定</button>
                    </div>
                </div>
            </el-dialog>
            <pdf-popup
                base64
                :visible="pdfVisible"
                :need-time="needTime"
                :read-file-info-list="currentFileInfoList"
                v-on:close="pdfVisible = false"
            ></pdf-popup>
            <my-dialog
                :title="agrData.title"
                :visible.sync="agrVisible"
                :dialog-close="agrVisibleHide"
                width="800px"
            >
                <div class="protocol-detail" v-html="agrData.content"></div>
                <div class="align-c">
                    <el-button type="primary" style="width: 180px" v-on:click="agrVisible = false">
                        确定
                    </el-button>
                </div>
            </my-dialog>
            <fund-protocol v-model="protocol" :fund="protocolFund" v-on:all-read="generalBuy" />
        </div>
        <footer-questions
            v-if="$const.warmReminderDisplay"
            :warning-html="warningHtml"
        ></footer-questions>
    </div>
</template>
<script>
import selectBank from "@/components/layout/selectBank.vue";
import userApi from "@/api/user";
import commonApi from "@/api/common";
import mixin from "@/assets/js/mixin";
import PdfPopup from "@/components/util/pdfPopup";
import fundApi from "@/api/fund";
import myDialog from "@/components/layout/myDialog.vue";
import fundProtocol from "@/components/form/fundProtocol";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";
import AmountInput from "@/components/common/AmountInput.vue";
import format from "date-fns/format";
import { sceneEnum } from "@/util/util_jfit";

export default {
    name: "MoneyOut",
    components: {
        selectBank,
        PdfPopup,
        myDialog,
        fundProtocol,
        footerQuestions,
        AmountInput
    },
    mixins: [mixin],
    data() {
        return {
            format: format,
            fund: {},
            fundcode: "",
            xjbFundFile: [],
            xjbFundFileFlag: false,
            currentFileInfoList: [], // 当前阅读信批文件
            checkboxs: [],
            pdfVisible: false,
            protocol: false,
            protocolFund: {},
            needTime: false,
            agrVisible: false,
            agrData: {},
            pla: "请输入取出金额",
            isOpen: false,
            fundInfo: {
                pay: "",
                availableMoney: "0",
                amount: "",
                sell: "0",
                pwd: ""
            },
            isPwdCheck: false,
            resultDialog: false,
            selectBankShow: false,
            dialogBankLists: [],
            bankInfo: {},
            limit: { text: "取出金额范围为：", min: "0", max: "0" }, // 限额
            rules: {
                // 校验规则配置
                pay: [
                    {
                        required: true,
                        message: "请选择取出账号",
                        trigger: "change"
                    }
                ],
                amount: [
                    {
                        validator: this.amountLimit,
                        mes: "取出金额",
                        trigger: "change"
                    }
                ],
                sell: [
                    {
                        required: true,
                        message: "请选择取出方式",
                        trigger: "change"
                    }
                ],
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            limitData: {
                minredemptionvol: "0",
                maxredemptionvol: "0",
                fastminredemptionvol: "0",
                fastmaxredemptionvol: "0"
            },
            warningHtml: "",
            fastLimitPen: "0",
            fastLimitDay: "0",
            protocolArr: [],
            agrType: sceneEnum.quickSell, // 协议类型 快赎
            checkbox: false, // 阅读确认
            ransDateInfo: {}, // 交易信息
            redeemInfo: {} // 产品限额信息
        };
    },
    computed: {
        disabeldFlag() {
            if (this.checkboxs.length == 0) {
                return false;
            }
            for (let i = 0; i < this.checkboxs.length; i++) {
                if (!this.checkboxs[i].checkbox) {
                    return true;
                }
            }
            return false;
        }
    },
    watch: {
        "fundInfo.sell"(val) {
            let bankSetMin = "0";
            let bankSetMax = "0";
            if (val == "0") {
                this.dialogBankLists.forEach((item) => {
                    item.perdaymax = this.limitData.maxredemptionvol;
                    item.maxlimitsingle = this.limitData.maxredemptionvol;
                });
                bankSetMin = this.limitData.minredemptionvol;
                bankSetMax = this.limitData.maxredemptionvol;
            } else {
                this.dialogBankLists.forEach((item) => {
                    item.perdaymax = this.fastLimitDay;
                    item.maxlimitsingle = this.fastLimitPen;
                });
                bankSetMin = this.limitData.fastminredemptionvol;
                bankSetMax = Math.min(
                    Number(this.limitData.fastmaxredemptionvol),
                    Number(this.bankInfo.fastavailfundvol)
                );
            }
            this.$set(this.limit, "min", bankSetMin);
            this.$set(
                this.limit,
                "max",
                Number(bankSetMax) - Number(this.fundInfo.availableMoney) > 0
                    ? this.fundInfo.availableMoney
                    : bankSetMax
            );
            this.pla =
                this.$util.fmtNum(this.limit.min) +
                "元起，最多可取现" +
                this.$util.fmtNum(this.limit.max) +
                "元";
            if (this.protocolArr.length == 0 && val == "1") {
                this.$message.error(
                    `缺失快速赎回协议，请联系【${this.$cache.getCompanyInfoParam("10101009")}】`
                );
            }
        }
    },
    mounted() {
        this.warningHtml = warningHtml.warningHtml12;
        this.isPwdCheck = this.$cache.getPwdCheck("024");
        this.queryXjbFundInfo();
        this.getAgreement(); // 获取快速赎回协议
    },
    methods: {
        // 查询现金宝信息
        async queryXjbFundInfo() {
            // 优先从 sessionStorage 获取缓存的现金宝信息
            const cachedXjbFundInfo = sessionStorage.getItem("xjbFundInfo");
            if (cachedXjbFundInfo) {
                const xjbFundInfo = JSON.parse(cachedXjbFundInfo);
                if (xjbFundInfo && xjbFundInfo.fundcode) {
                    this.fund = xjbFundInfo;
                    this.fundcode = xjbFundInfo.fundcode;
                }
            }

            // 缓存不存在时，调用接口查询
            const res = await fundApi.cfgFundrealtimeQueryAll();
            if (res.data && res.data.length > 0) {
                this.fundcode = res.data && res.data[0] && res.data[0].fundcode;
            }
            if (!this.fundcode) {
                this.$message({
                    type: "warning",
                    message: "未配置现金宝信息！"
                });
                return false;
            }
            const fundRes = await fundApi.getFundLists({
                fundcode: this.fundcode,
                pagesize: 10,
                pagenum: 1
            });
            if (fundRes.data) {
                this.fund = fundRes.data.list[0];
                this.getBuyWay();
                this.getSellInfo();
                this.getFileInfo();
                this.qryTransDateInfo();
            }
        },
        // 赎回前数据查询
        async getSellInfo() {
            let rs = await fundApi.qryBeforeRedeem({
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype
            });
            if (rs.error) {
                return;
            }
            this.redeemInfo = rs.data;
        },
        // 获取赎回日期
        async qryTransDateInfo() {
            const res = await fundApi.qryTransDateInfo({
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype
            });
            this.ransDateInfo = res && res.data;
        },
        // 赎回前查询
        async getBuyWay() {
            this.xjbFundFileFlag = false;
            let rs = await fundApi.combQueryFundlimit({
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype,
                businesscode: "024",
                invtp: "1",
                transflag: "1"
            });
            if (rs.data) {
                this.limitData.minredemptionvol = rs.data.minamount;
                this.limitData.maxredemptionvol = rs.data.maxamount;
                const fastRes = await fundApi.combQueryFundlimit({
                    fundcode: this.fund.fundcode,
                    businesscode: "098",
                    invtp: "1",
                    transflag: "1"
                });
                if (fastRes.data) {
                    this.limitData.fastminredemptionvol = fastRes.data.minamount;
                    this.limitData.fastmaxredemptionvol = fastRes.data.maxamount;
                    this.fastLimitPen = fastRes.data.maxamount;
                    this.fastLimitDay = fastRes.data.maxfastredeem;
                }
            }
            const res = await fundApi.getHoldingAssets({
                fundcode: this.fund.fundcode
            });
            // 需要展示现金宝产品和普通现金宝产品
            res.data.returnList = res.data.returnList.filter((item) => {
                return Number(item.usableremainshare) > 0;
            });
            this.dialogBankLists = res.data.returnList;

            this.dialogBankLists.forEach((item) => {
                item.perdaymax = this.limitData.maxredemptionvol;
                item.maxlimitsingle = this.limitData.maxredemptionvol;
            });
            this.xjbFundFileFlag = true;
        },
        // 获取提示文件信息
        async getFileInfo() {
            this.fund.proto = "sell";
            this.xjbFundFileFlag = false;
            this.$util.getSdxProtocol(this.fund, (res) => {
                this.fund = res;
                this.protocolFund = JSON.parse(JSON.stringify(res));
                this.protocolFund.protoArr = [];
                if (res.protoArr && res.protoArr.length > 0) {
                    res.protoArr.forEach((item) => {
                        item.filename = item.title;
                        if (item.fileid == null || !item.fileid) {
                            item.fileid = "";
                        }
                        this.xjbFundFile.push(item);
                        this.checkboxs.push({ checkbox: false });
                    });
                }
                this.xjbFundFileFlag = true;
            });
        },
        getClick(index) {
            this.currentFileInfoList = [this.xjbFundFile[index]];
            this.needTime = false;
            this.pdfVisible = true;
        },
        backFn() {
            this.$router.push({
                name: "moneybox"
            });
        },
        submitInfo() {
            this.$refs["fundInfo"].validate((valid) => {
                if (valid) {
                    if (this.fundInfo.sell == "1" && this.signAgreement()) {
                        if (this.checkbox) {
                            this.protocol = true;
                        }
                    } else if (this.fundInfo.sell == "0") {
                        this.protocol = true;
                    }
                    if (this.protocol && this.fundInfo.sell == "0" && this.xjbFundFile.length > 0) {
                        commonApi.agreementLeaveTracesLog(
                            this,
                            {
                                eventid: this.$const.RECORD.cms_protocol_agreement_agree + "/o",
                                eventname: `协议同意`
                            },
                            this.xjbFundFile
                        );
                    }
                    if (this.protocol && this.fundInfo.sell == "1" && this.protocolArr.length > 0) {
                        commonApi.agreementLeaveTracesLog(
                            this,
                            {
                                eventid: this.$const.RECORD.cms_protocol_agreement_agree + "/B",
                                eventname: `协议同意`
                            },
                            this.protocolArr
                        );
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        // 同意快速赎回协议
        signAgreement() {
            if (this.checkbox) {
                this.tracesLog(this.protocolArr);
                return true;
            }
            let protocol = "";
            this.protocolArr.forEach((item) => {
                protocol += `《${item.title}》`;
            });
            this.$confirm(`您还没有签署${protocol}，是否同意签署？`, {
                confirmButtonText: "同意",
                cancelButtonText: "不同意",
                type: "warning"
            }).then(() => {
                this.tracesLog(protocol);
                this.checkbox = true;
                return true;
            });
        },
        // 留痕同意快速赎回协议
        tracesLog(protocol) {
            commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.quick_redemption_agreement,
                eventname: `同意快速赎回协议`,
                content: JSON.stringify({ name: protocol })
            });
        },
        getAgreement() {
            this.$util.getProtocol(this.agrType).then((res) => {
                if (res && res.length > 0) {
                    this.protocolArr = res;
                }
            });
        },
        generalBuy(val) {
            this.protocol = false;
            if (!val) return;
            let data = {
                transactionaccountid: this.bankInfo.transactionaccountid,
                sharetype: this.bankInfo.sharetype,
                tradepassword: this.$util.enc(this.fundInfo.pwd),
                applicationvol: this.fundInfo.amount
            };
            // 下单
            this.planOpen(data);
        },
        async planOpen(params) {
            this.isOpen = true;

            try {
                let requestFn;
                let requestParams;

                if (this.bankInfo.transtype === "1") {
                    requestFn = fundApi.combTransRealtaRedeem;
                    requestParams = {
                        ...params,
                        fastredeemflag: this.fundInfo.sell
                    };
                } else {
                    requestFn = fundApi.redeemAsset;
                    requestParams = {
                        ...params,
                        largeredemptionflag: "1",
                        fundcode: this.fund.fundcode,
                        selltype: this.fundInfo.sell,
                        referid: "",
                        referralname: ""
                    };
                }

                const res = await requestFn(requestParams);

                if (res && res.data) {
                    this.resultDialog = true;
                }
            } catch (e) {
                this.$log.error("planOpen error:", e);
            } finally {
                this.isOpen = false;
            }
        },
        // 处理限额
        amountLimit(rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        selectBank() {
            this.selectBankShow = true;
        },
        selectBankClose(value) {
            this.selectBankShow = false;
        },
        selectBankInfo(bankInfo) {
            this.bankInfo = bankInfo;
            this.fundInfo.pay =
                this.$util.getChannelName(
                    this.bankInfo
                ) +
                "(" +
                this.$util.lastFour([
                    this.bankInfo.desendepositcard,
                    this.bankInfo.depositcardproc,
                    this.bankInfo.depositcard
                ]) +
                ")";
            this.fundInfo.availableMoney = this.bankInfo.usableremainshare
                ? this.bankInfo.usableremainshare
                : "0.00";
            const bankSetMin =
                this.fundInfo.sell == "0"
                    ? this.limitData.minredemptionvol
                    : this.limitData.fastminredemptionvol;
            const bankSetMax =
                this.fundInfo.sell == "0"
                    ? this.limitData.maxredemptionvol
                    : Math.min(
                          Number(this.limitData.fastmaxredemptionvol),
                          Number(this.bankInfo.fastavailfundvol)
                      );
            this.$set(this.limit, "min", bankSetMin);
            this.$set(
                this.limit,
                "max",
                Number(bankSetMax) - Number(this.fundInfo.availableMoney) > 0
                    ? this.fundInfo.availableMoney
                    : bankSetMax
            );
            this.pla =
                this.$util.fmtNum(this.limit.min) +
                "元起，最多可取现" +
                this.$util.fmtNum(this.limit.max) +
                "元";
        },
        agrVisibleHide() {
            this.agrVisible = false;
        },
        argRead(item) {
            this.agrVisible = true;
            this.agrData = item;
        },
        resultDialogClose() {
            this.resultDialog = false;
            this.$router.push({ name: "moneybox" });
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-money-out {
    width: 1200px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    margin-top: 13px;
    padding-top: 40px;
    margin-bottom: 20px;
    .payway-list {
        position: relative;
        .hot-area {
            width: 400px;
            height: 40px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 99 !important;
            cursor: pointer;
        }
        .add-bank-btn {
            position: absolute;
            left: 410px;
            font-size: 14px;
            font-weight: normal;
            color: #1890ff;
            cursor: pointer;
        }
    }
    .available-money-box {
        display: flex;
        align-items: center;
        .available-money {
            font-size: 22px;
            font-weight: normal;
            color: var(--color-primary);
            vertical-align: top;
        }
        .money-in {
            text-align: center;
            padding: 5px 9px;
            height: 26px;
            line-height: 26px;
            border-radius: 20px;
            background: #ffecec;
            font-size: 14px;
            font-weight: normal;
            color: var(--color-primary);
            margin-left: 29px;
            cursor: pointer;
        }
    }

    .back-btn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        background: #e4e4e4;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #666666;
        border: none;
        cursor: pointer;
    }
    .confirm-btn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        border: none;
        margin-left: 40px;
    }
    .active-btn {
        background: var(--color-primary);
        cursor: pointer;
    }
    .disable-btn {
        background: #f7b2b8;
    }
    .success-res {
        margin: 40px 0 30px;
        width: 660px;
        height: 242px;
        border-radius: 6px;
        background: #f9f9f9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .success-text {
            font-size: 26px;
            font-weight: 500;
            margin-top: 23.85px;
            color: #333333;
        }
    }
    .btn-box {
        text-align: center;
        padding-bottom: 56px;
        .btn-confirm {
            width: 180px;
            text-align: center;
            height: 42px;
            line-height: 42px;
            border-radius: 2px;
            background: var(--color-primary);
            color: #ffffff;
            border: none;
            cursor: pointer;
        }
    }
    .file-content {
        text-decoration: none;
        color: var(--color-primary);
        cursor: pointer;
    }
    .protocol-detail {
        padding: 20px 10px;
        max-height: 80vh;
        min-height: 10vh;
        overflow: scroll;
    }
    .el-input,
    .el-select {
        width: 400px;
    }
    .el-input__inner {
        font-size: 22px !important;
        font-weight: normal;
        color: #333333;
    }
    .margin-l-10 {
        margin-left: 10px;
    }
    :deep(.el-form-item__label) {
        padding: 0;
        font-size: 14px;
        font-weight: normal;
        color: #333333;
    }
    :deep(.el-form-item__label:before) {
        display: none;
    }
    .padding-t-10 {
        padding-top: 10px;
    }
    .padding-t-10 {
        padding-top: 10px;
    }
    .margin-t-5 {
        margin-top: 5px;
    }
    .sell-font {
        font-size: 14px;
        color: #999999;
    }
}

/* 协议勾选框统一样式 */
.protocol-checkbox-group {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    
    .protocol-checkbox-label {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        line-height: 40px;
        
        input[type="checkbox"] {
            width: 18px;
            height: 18px;
            margin: 0;
            cursor: pointer;
        }
        
        span {
            padding-left: 5px;
            color: red;
        }
    }
    
    ul {
        margin: 0;
        padding: 0;
        list-style: none;
        
        li {
            line-height: 40px;
            
            a {
                color: var(--color-redirect);
                text-decoration: none;
                cursor: pointer;
                
                &:hover {
                    color: var(--color-primary);
                }
            }
        }
    }
}
</style>
